exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.filter-expansion-panel .v-expansion-panel-header__icon {\n    margin-left: 8px !important;\n}\n", ""]);
